/**
 * The four legal documents, by slug.
 *
 * Each document is a plain data file in this folder. To change what a page
 * says, edit that file — nothing here and no component needs to change.
 *
 * To add a fifth document:
 *   1. add its data file here, in the same shape,
 *   2. add it to LEGAL_DOCUMENTS below,
 *   3. add its route to src/App.js and to src/components/Seo/config.js,
 *   4. add it to the footer, public/llms.txt and public/sitemap.xml.
 *
 * See docs/aeo/AEO-LEDGER.md, task 9.
 */

import guestAgreement from './guest-agreement';
import hostAgreement from './host-agreement';
import privacy from './privacy';
import terms from './terms';

export const LEGAL_DOCUMENTS = [terms, privacy, hostAgreement, guestAgreement];

export const findDocument = (slug) => LEGAL_DOCUMENTS.find((doc) => doc.slug === slug) || null;

// Billing B4.4: the version a person agrees to = each document's `lastUpdated`.
// The server has the same dates (functions/helper/terms.js); a test checks them.
export const termsVersion = () => ({
  terms: terms.lastUpdated,
  guestTerms: guestAgreement.lastUpdated,
  hostTerms: hostAgreement.lastUpdated,
  privacy: privacy.lastUpdated
});
